<template>
    <div>
        <b-row class="hidden-sm-down">
            <b-col class="text-center" cols="12">
                <img alt="Arkeon" src="../assets/logo.png">
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" class="text-center">
                <h1>Connexion</h1>
            </b-col>
        </b-row>
        <b-row class="justify-content-center">
            <b-col cols="12" md="6">
                <b-form @submit.prevent.stop="onSubmit">
                    <b-alert variant="danger" :show="form.errors.length > 0">
                        <p class="mb-0" v-for="error in form.errors" v-bind:key="error">{{error}}</p>
                    </b-alert>
                    <b-form-group label="Identifiant" description="Adresse email" label-for="login-email">
                        <b-form-input id="login-email" type="email" v-model="form.login" required placeholder="Identifiant"/>
                    </b-form-group>
                    <b-form-group label="Mot de passe" label-for="login-password">
                        <b-form-input ref="password" id="login-password" type="password" v-model="form.password" required placeholder="Mot de passe"/>
                    </b-form-group>
                    <b-form-group>
                        <b-checkbox v-model="form.rememberLogin">Se souvenir de mon identifiant</b-checkbox>
                    </b-form-group>
                    <div class="text-center">
                        <b-button type="submit" variant="primary" :disabled="processing">Connexion</b-button>
                    </div>
                </b-form>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import axios from 'axios';
    import {API_URL} from '../variables'

    export default {
        name: "Login",
        data() {
            return {
                form: {
                    login: "",
                    password: "",
                    rememberLogin: false,
                    errors: []
                },
                processing: false
            }
        },
        mounted() {
            if (localStorage.getItem("rememberLogin")) {
                this.form.rememberLogin = localStorage.getItem("rememberLogin");
                this.form.login = localStorage.getItem("login");
            }
            if (localStorage.getItem("authKey")) {
                axios
                    .get(API_URL + "/user/info")
                    .then((response) => {
                        this.$root.userInfo = response.data;
                        this.$router.replace({name: "home"});
                    });
            }
        },
        methods: {
            onSubmit() {
                this.form.errors = [];
                if (this.form.login.trim() !== "" && this.form.password.trim() !== "") {
                    localStorage.setItem("rememberLogin", this.form.rememberLogin);
                    localStorage.setItem("login", this.form.login);
                    this.processing = true;
                    axios
                        .post(API_URL + "/user/login",
                            {login: this.form.login, password: this.form.password})
                        .then((response) => {
                            if (response.data.key == null) {
                                this.form.errors.push("Le serveur a renvoyé une réponse invalide");
                            } else {
                                localStorage.setItem("authKey", response.data.key);
                                this.$router.push("home");
                            }
                        })
                        .catch((error) => {
                            let response = error.response;
                            if (response) {
                                if (response.status === 401) {
                                    this.form.errors.push("Les informations de connexion sont erronées");
                                    this.form.password = "";
                                    this.$refs.password.focus();
                                    return;
                                }
                            }
                            this.form.errors.push("Une erreur est survenue lors du traitement de la requête")
                        })
                        .finally(() => {
                            this.processing = false;
                        });
                } else {
                    this.form.errors.push("Vous devez saisir un identifiant et un mot de passe");
                }
            }
        }
    }
</script>

<style scoped>

</style>